/* eslint-disable max-len */
import { RouteRecordRaw } from 'vue-router';
import { metaRequireGuest } from '@/router/meta-constants';

const authenticateRoutes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    meta: metaRequireGuest,
    component: () => import(/* webpackChunkName: "authenticate" */ '@/views/authenticate/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: metaRequireGuest,
    component: () => import(/* webpackChunkName: "authenticate" */ '@/views/authenticate/Register.vue')
  }
];

export default authenticateRoutes;
